import {ReactNode} from 'react';

import {createMandatoryContext} from '../../../../../helpers/src/react/reactHelpers';

/*
 * Props.
 */

export interface ButtonGroupContextProps {
  allSameWidthChildren: ReadonlyArray<ReactNode>;
}

/*
 * Context.
 */

const [ButtonGroupContext, useButtonGroupContext] = createMandatoryContext<ButtonGroupContextProps>();
export const ButtonGroupContextProvider = ButtonGroupContext.Provider;

/*
 * Hook.
 */

export function useButtonGroupSameWidthChildren() {
  return useButtonGroupContext().allSameWidthChildren;
}
